import { render, staticRenderFns } from "./integralDetail.vue?vue&type=template&id=2ed19883&scoped=true"
import script from "./integralDetail.vue?vue&type=script&lang=js"
export * from "./integralDetail.vue?vue&type=script&lang=js"
import style0 from "./integralDetail.vue?vue&type=style&index=0&id=2ed19883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed19883",
  null
  
)

export default component.exports